<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">
    <div class="contents-wrapper">
      <div class="main-contents">
        <detail-row-component title="와인명">{{ editable.wineFullName }}</detail-row-component>

        <detail-row-component title="품종">
          <layout-multiple-auto-complete v-model="editable.grapes" api-url="/api/grapes" :http-options="httpOptions"
            track-by="id" track-name="name" place-holder="포도 품종을 최대 3개 선택하세요." :depth="50" :max="3" />
        </detail-row-component>

        <detail-row-component title="아로마" :inner-vertical="true">
          <layout-multiple-auto-complete v-model="aromas" api-url="/api/aromas" :http-options="httpOptions"
            track-by="id" track-name="name" place-holder="향기 5가지를 검색하여 선택해주세요." :min="5" />
        </detail-row-component>

        <detail-row-component title="용량">
          <layout-radio-button v-model="editable.volume" :name="`volume${rowIndex}`"
            :select-list="[375, 750, 1500, 3000]" :view-list="['375ML', '750ML', '1500ML', '3000ML']" />
        </detail-row-component>

        <detail-row-component title="용량 직접 입력">
          <layout-input v-model="editable.volume" placeholder="용량을 직접 입력하세요." type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="알코올 도수">
          <layout-input v-model="editable.abv" placeholder="알코올 도수를 입력해주세요. ex) 13.5" :regex="regex(1, 5).num_dot"
            type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="상세 이미지2" innerVertical>
          <layout-detail-images v-model="editable.detailImgs" :row-index="rowIndex"
            :on-image-out-of-size="onImageOutOfSize" />
          <layout-blank :value="8" />
          <layout-info title="* 상세 이미지 사이즈 : 1440 X 1440" infoType="warn" />
        </detail-row-component>

        <detail-row-component title="라벨 이미지" innerVertical>
          <layout-image-selector v-model="editable.imgLabel" :index="`image_label${rowIndex}`"
            :on-image-out-of-size="onImageOutOfSize" />
          <layout-info title="* 라벨 이미지 최대 사이즈 : 1440 X 1440" infoType="warn" />
        </detail-row-component>

        <detail-row-component title="와인 설명">
          <layout-textarea v-model="editable.wineDsc" />
        </detail-row-component>

        <detail-row-component title="바디감">
          <layout-input v-model="editable.body" placeholder="1~5.0 사이의 값을 입력해주세요." :regex="regex(1, 3).num_dot"
            type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="신맛">
          <layout-input v-model="editable.acidity" placeholder="1~5.0 사이의 값을 입력해주세요." :regex="regex(1, 3).num_dot"
            type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="탄닌">
          <layout-input v-model="editable.tannin"
            :placeHolder="editable.type === null ? '색상이 지정이 안되어 있습니다. 색상을 지정 해주세요.' : editable.type === '레드' ? '1~5.0 사이의 값을 입력해주세요.' : '레드 와인이 아닙니다!'"
            :regex="editable.type === null ? '' : editable.type === '레드' ? regex(1, 3).num_dot : ''"
            :is-disabled="editable.type !== '레드'" type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="단맛">
          <layout-input v-model="editable.sweetness"
            :placeHolder="editable.type === null ? '색상이 지정이 안되어 있습니다. 색상을 지정 해주세요.' : editable.type !== '레드' ? '1~5.0 사이의 값을 입력해주세요.' : '화이트 / 로제 와인이 아닙니다!'"
            :regex="editable.type === null ? '' : editable.type !== '레드' ? regex(1, 3).num_dot : ''"
            :is-disabled="editable.type === '레드'" type="number" isFloat />
        </detail-row-component>
      </div>
    </div>
  </detail-row-wrapper>
</template>

<script>
import { regex } from "@/utils/utils"

import DetailRowWrapper from "@/spa/components/detail-row/DetailRowWrapper"
import DetailRowComponent from "@/spa/components/detail-row/DetailRowComponent"

import LayoutImageSelector from "@/spa/components/LayoutImageSelector"
import LayoutInput from "@/spa/components/LayoutInput"
import LayoutTextarea from "@/spa/components/LayoutTextarea"
import LayoutRadioButton from "@/spa/components/LayoutRadioButton"
import LayoutInfo from "@/spa/components/LayoutInfo"
import LayoutBlank from "@/spa/components/LayoutBlank"

import LayoutDetailImages from "@/spa/components/board/wine/details/detail-row/LayoutDetailImages"

import LayoutMultipleAutoComplete from "@/spa/components/LayoutAsyncMultipleAutoComplete"

export default {
  name: "DetailRowEditor",
  components: {
    DetailRowWrapper,
    DetailRowComponent,

    LayoutImageSelector,
    LayoutInput,
    LayoutTextarea,
    LayoutRadioButton,
    LayoutDetailImages,
    LayoutInfo,
    LayoutBlank,

    LayoutMultipleAutoComplete
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    aromas: {
      get() {
        return this.editable.aromas.map(aroma => aroma.id)
      },
      set(value) {
        this.editable.aromas = value.map(aroma => ({ id: aroma }))
      }
    },
    httpOptions() {
      return { headers: { Authorization: this.$store.getters.getToken } }
    }
  },
  methods: {
    onImageOutOfSize() {
      this.$toast("사이즈가 4메가가 넘습니다.")
    },

    regex(min, max) {
      return regex(min, max)
    },

    async uploadImage(image) {
      if (!image) return null
      if (typeof image === "string") return image

      const result = await this.$store.dispatch("imageUploadS3", {
        name: "details",
        image
      })

      if (!result.response) return image
      this.$toast(result.message)
      this.$toast("데이터베이스 업로드 작업중 입니다. 조금만 기다려주세요.")

      return result.response.location
    },

    async uploadImages(images) {
      if (!images) return [null, null, null, null]

      console.log("uploadImages", images)

      if (typeof images[0] === "string") return images

      const result = await this.$store.dispatch("imagesUploadS3", {
        name: "details",
        images
      })

      if (!result.response) return images
      this.$toast(result.message)
      this.$toast("데이터베이스 업로드 작업중 입니다. 조금만 기다려주세요.")

      return result.response
    },

    async submit() {
      this.editable.wineId = parseInt(this.rowData.wine_id, 10)
      this.editable.imgLabel = await this.uploadImage(this.editable.imgLabel)
      this.editable.detailImgs = await this.uploadImages(
        this.editable.detailImgs
      )

      const result = await this.$store.dispatch("updateDetail", this.editable)

      if (result.response) {
        this.$table.updateField()
      }

      this.$toast(result.message)
    },

    cancel() {
      this.$table.updateField()
    }
  },
  data() {
    return {
      editable: {
        wineFullName: this.rowData.wine_full_name,
        type: this.rowData.type,
        grapes: this.rowData.grapes || [],
        volume: this.rowData.volume,
        abv: this.rowData.abv,
        detailImgs: this.rowData.detail_imgs == null || this.rowData.detail_imgs.length >= 4 ? this.rowData.detail_imgs : [null, null, null, null],
        imgLabel: this.rowData.img_label || null,
        wineDsc: this.rowData.wine_dsc,
        body: this.rowData.body,
        acidity: this.rowData.acidity,
        tannin:
          this.rowData.type === null
            ? null
            : this.rowData.type === "레드"
              ? this.rowData.tannin
              : null,
        sweetness:
          this.rowData.type === null
            ? null
            : this.rowData.type !== "레드"
              ? this.rowData.sweetness
              : null,
        aromas: this.rowData.aromas || []
      },

      tempArr: []
    }
  }
}
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: 600px;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;

    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/wine/details/detail-row/WineDetailEditor.vue